/* eslint no-undef: 'off' */
/* eslint no-console: 'off' */
import $ from "jquery";


const bookingFilter = () => {
    const target = ".wb-ProductOverview__Filter";
    const $target = $(target);

    const init = () => {
        if ($target.length) {
            exec();
        }
    };

    const exec = () => {
        $('.js-Filter__Button').each(function () {
            $(this).on('click', function(){
                const dataTypeFilter = $(this).data('filter-type');
                $('.wb-ProductOverview__Filter span').removeClass('active');
                $(this).addClass('active');

                const ajax = themeObj.booking_filter;
                    
                const data = {
                    action: ajax.action,
                    nonce: ajax.nonce,
                    dataTypeFilter: dataTypeFilter,
                };
        
                $.ajax({
                    url: themeObj.ajaxUrl,
                    type: "POST",
                    data: data,
                    success: function (response) {
                        $('.wb-ProductOverview.Filtered').html(response.data);    
                    },
                    error: function (error) {
                        console.error("Error sending data", error);
                    },
                });
            })
        })
    };

    init();
};

try {
    bookingFilter();
} catch (error) {
    throw Error(error);
}
